export default "__VITE_ASSET__c2a8e69e__"